import React from "react"

import FieldProto from "../../proto/field-proto"
import TasksViewManager from "../../../gd-modules/tasks-view/core/manager"
import ItemModelV2 from "../../../model2/item2/item-model"
import TasksView_Column from "../../../model2/column/column"
import CustomFieldUpgradeGuard from "../custom-field-upgrade-guard"

export type FieldTableCellProps = {

    className?      : string    // do we need it ?
    field           : FieldProto
    listItem        : ItemModelV2 // vmesto model
    model?          : any // Experimental if passed - use it instead of listItem.model used in some advanced cases like table view for TimeReport where field = task i.e. timeReport.task
    manager         : TasksViewManager // TableManager OR List manager  huh !
    column          : TasksView_Column        // TableColum
    style?          : style

    configOptions?  : any
    disabled?       : boolean

    onChange?       : onChangeCallback // ? a nahrena ono

    onFocus?        : callback      // this one is used in table to prevent dnd when input in focus i.e. we want to copy current value
    onBlur?         : callback      // this one is used in table to prevent dnd when input in focus i.e. we want to copy current value
};

export type FieldTableCellState = {
    isHovered       : boolean
    showPopover     : boolean
}

type TableCellStyleProps = {
    column          : TasksView_Column        // TableColum
    style?          : style
}

export function getTableCellStyle(props: TableCellStyleProps): style {

    // this is common part for table cell
    // end common part

    const width = props.column.width

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    return style
}


export default function FieldTableCell(props: FieldTableCellProps):React.ReactElement {
    // console.log(props.field.fieldId, props.field.renderComponents.tableCell)
    return (
        <CustomFieldUpgradeGuard isCustom={props.field.isCustom}>
            <props.field.renderComponents.tableCell
                {...props}
                key={props.field.fieldId}
            />
        </CustomFieldUpgradeGuard>
    )
}
